// extracted by mini-css-extract-plugin
export default {"wrapper":"MainCard_wrapper__Ql8ot"};